import { jsx } from "react/jsx-runtime";
import { marked } from "marked";
import React__default from "react";
import { StoreLocatorWidget } from "../components/StoreLocatorWidget/index.js";
import { SurveyCarousel } from "../components/SurveyCarousel.js";
marked.use({
  gfm: true,
  breaks: true,
  pedantic: false,
  renderer: {
    link({ href, text }) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:inherit;">${text}</a>`;
    }
  }
});
const renderMessageContentWithCarousels = (text, productMetadataMap, streamingGroups, isStreaming = false, isAlreadyProcessed = false, onVariantSelect, surveyMetadataMap) => {
  const storeLocatorRegex = /<store_locator\s+stacklineSku\s*=\s*"([^"]+)"\s*\/?>/g;
  const storeLocators = [];
  let storeLocatorIndex = 0;
  const textWithStoreLocatorPlaceholders = text.replace(
    storeLocatorRegex,
    (match, stacklineSku) => {
      const placeholder = `@@STORE_LOCATOR_${storeLocatorIndex}@@`;
      storeLocators.push({
        placeholder,
        stacklineSku
      });
      storeLocatorIndex++;
      return placeholder;
    }
  );
  const surveyGroupRegex = /(?:<survey\s+campaignId\s*=\s*"[^"]+"[^>]*>[\s\S]*?<\/survey>|<survey\s+campaignId\s*=\s*"[^"]+"\s*\/>)(?:\s*(?:<survey\s+campaignId\s*=\s*"[^"]+"[^>]*>[\s\S]*?<\/survey>|<survey\s+campaignId\s*=\s*"[^"]+"\s*\/>))*/g;
  const surveyGroups = [];
  let surveyGroupIndex = 0;
  const textWithSurveyPlaceholders = textWithStoreLocatorPlaceholders.replace(surveyGroupRegex, (groupMatch) => {
    const campaignIds = [];
    let match;
    const localRegex = /<survey\s+campaignId\s*=\s*"([^"]+)"[^>]*>[\s\S]*?<\/survey>|<survey\s+campaignId\s*=\s*"([^"]+)"\s*\/>/g;
    while ((match = localRegex.exec(groupMatch)) !== null) {
      campaignIds.push(match[1] || match[2]);
    }
    const placeholder = `@@SURVEY_GROUP_${surveyGroupIndex}@@`;
    surveyGroups.push({ placeholder, campaignIds });
    surveyGroupIndex++;
    return placeholder;
  });
  const htmlContent = marked.parse(textWithSurveyPlaceholders);
  const htmlContentWithoutHr = htmlContent.replace(/<hr\s*\/?>/gi, "");
  const htmlContentWithWrappedTables = htmlContentWithoutHr.replace(
    /<table[\s\S]*?<\/table>/gi,
    (match) => `<div class="table-scroll-wrapper">${match}</div>`
  );
  const parts = htmlContentWithWrappedTables.split(
    /(@@STORE_LOCATOR_\d+@@|@@SURVEY_GROUP_\d+@@)/
  );
  return parts.map((part, idx) => {
    const storeLocatorMatch = part.match(/@@STORE_LOCATOR_(\d+)@@/);
    if (storeLocatorMatch) {
      const storeLocatorIdx = parseInt(storeLocatorMatch[1]);
      const storeLocator = storeLocators[storeLocatorIdx];
      if (storeLocator) {
        return /* @__PURE__ */ jsx(
          StoreLocatorWidget,
          {
            stacklineSku: storeLocator.stacklineSku
          },
          `store-locator-${idx}-${storeLocator.stacklineSku}`
        );
      }
      return /* @__PURE__ */ jsx(React__default.Fragment, {}, `store-locator-missing-${idx}`);
    }
    const surveyGroupMatch = part.match(/@@SURVEY_GROUP_(\d+)@@/);
    if (surveyGroupMatch) {
      const groupIdx = parseInt(surveyGroupMatch[1]);
      const group = surveyGroups[groupIdx];
      if (group && surveyMetadataMap) {
        const surveysWithMetadata = [];
        for (const campaignId of group.campaignIds) {
          const surveyData = surveyMetadataMap.get(campaignId);
          if (surveyData) {
            surveysWithMetadata.push(surveyData);
          } else if (process.env.NODE_ENV === "development") {
            console.warn(
              `SurveyCarousel: Survey metadata not found for campaignId: ${campaignId}. Available campaignIds: ${Array.from(surveyMetadataMap.keys()).join(", ")}`
            );
          }
        }
        if (surveysWithMetadata.length > 0) {
          return /* @__PURE__ */ jsx(SurveyCarousel, { surveys: surveysWithMetadata }, `survey-group-${idx}`);
        }
      }
      return /* @__PURE__ */ jsx(React__default.Fragment, {}, `survey-group-empty-${idx}`);
    }
    if (!part.trim()) {
      return /* @__PURE__ */ jsx(React__default.Fragment, {}, `empty-${idx}`);
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        style: { display: "flex", flexDirection: "column" },
        dangerouslySetInnerHTML: { __html: part },
        className: "message-markdown"
      },
      idx
    );
  });
};
export {
  renderMessageContentWithCarousels
};
//# sourceMappingURL=messageRenderer.js.map
